const initialState = [];
const buyerbidreducer = (state = initialState, action ) => {
    switch (action.type) {
        case "BUYERBID":
      return action.data;
    default:
      return state;
    }
}

export default buyerbidreducer;
